import Swal from "sweetalert2";
import useServiceApi from "../../../../../modules/pages/newLetterBulk/hooks/useServiceApi";
import getCompany from "./getCompany";
import getSenderAddress from "./getSenderAddress";

const doSubmit = async ({
  values,
  set,
  setLoading,
  needPrint,
  needSMS,
  needCollecting,
}) => {
  if (values.items.length === 0) return;

  const senderAddress = getSenderAddress();

  if (senderAddress === undefined) {
    Swal.fire({
      icon: "error",
      confirmButtonText: "متوجه شدم",
      confirmButtonColor: "gray",
      text: "آدرس فرستنده (مبدا) مشخص نشده است",
    });

    return;
  }

  if (getCompany().value === -1) {
    Swal.fire({
      icon: "error",
      confirmButtonText: "متوجه شدم",
      confirmButtonColor: "gray",
      text: "نوع سرویس دهنده را انتخاب نکردید",
    });

    return;
  }

  setLoading(true);

  const serviceApi = useServiceApi;
  const response = await Promise.all(
    values.items.map((item, index) =>
      serviceApi(
        {
          SAddress: senderAddress,
          selectedService: getCompany().selected,
          newItem: item,
        },
        needPrint,
        needSMS,
        index,
        1,
        needCollecting,
        4
      )
    )
  );

  const result = [];
  let hasZero = false;
  response.forEach(item => {
    result.push({
      ui: item.ui,
      price: item.price ? item.price : 0,
      totalPrice: item.totalPrice ?? 0,
    });
    if (!item.price) hasZero = true;
  });

  if (hasZero === true) {
    Swal.fire({
      icon: "error",
      title: "اخطار",
      html: "<p style='font-size: 20px'>کاربر گرامی :مرسولاتی که فیلد آن قرمز میباشد را بررسی ، تغییر ویا حذف نمائید و سپس دکمه تایید را بزنید </p><p style='font-size: 16px;color : red' >می‌توانید مرسولات حذف شده را با سرویس دیگر که امکان ارسال دارد ارسال کنید</p>",
      confirmButtonText: "متوجه شدم",
      confirmButtonColor: "gray",
      iconColor: "red",
    });
  }

  set(result);

  setLoading(false);
};

export default doSubmit;
